module.exports = __webpack_public_path__ + "static/media/md-bus.52a105e4.svg";